export const prevArrow = `
    <button aria-label="Previous slide" class="slider__arrow slider__prev slick-prev button">
        <svg class="icon icon--prev arrow-left" width="15" height="24" viewBox="0 0 15 24" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="transform: rotate(180deg)">
            <path d="M14.802 12 2.742 24.061.62 21.939 10.56 12 .62 2.061 2.742-.061 14.802 12Z" fill="currentColor" />
        </svg>
    </button>`;
export const nextArrow = `
    <button aria-label="Next slide" class="slider__arrow slider__next slick-next button">
        <svg class="icon icon--next arrow-right" width="15" height="24" viewBox="0 0 15 24" xmlns="http://www.w3.org/2000/svg" xml:space="preserve">
            <path d="M14.802 12 2.742 24.061.62 21.939 10.56 12 .62 2.061 2.742-.061 14.802 12Z" fill="currentColor" />
        </svg>
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 300,
    nextArrow,
    prevArrow
};

